import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from './Navigation';

const A16Z = () => {
  return (
    <div className="bg-black text-white">
      <Navigation />

      {/* Hero Section */}
      <div className="relative pt-20 pb-16 md:pt-32 md:pb-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-light tracking-wider mb-8">
              Check out what's happening in front of <span className="text-orange-400">a16z</span> now
            </h1>
            <p className="text-xl md:text-2xl text-white/80 font-light leading-relaxed mb-12">
              Here is a camera facing the Andreessen Horowitz building
            </p>
          </div>
        </div>
      </div>

      {/* Live Camera Feed Section */}
      <div className="container mx-auto px-4 mb-20">
        <div className="max-w-4xl mx-auto">
          <div className="relative rounded-lg overflow-hidden shadow-2xl">
            <iframe
              src="https://g1.ipcamlive.com/player/player.php?alias=68408c288eb1f"
              width="100%"
              height="600px"
              frameBorder="0"
              allowFullScreen
              className="w-full"
            ></iframe>
          </div>
        </div>
      </div>

      {/* Quote Section */}
      <div className="container mx-auto px-4 mb-20">
        <div className="max-w-3xl mx-auto">
          <div className="bg-gradient-to-r from-black via-orange-950/20 to-black p-8 md:p-12 rounded-lg border border-orange-900/30">
            <blockquote className="text-xl md:text-2xl font-light italic text-white/90 leading-relaxed mb-6">
              "The world is a very malleable place. If you know what you want, and you go for it with maximum energy and drive and passion, the world will often reconfigure itself around you much more quickly and easily than you would think."
            </blockquote>
            <p className="text-right text-orange-400 font-light">
              ― Marc Andreessen
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-black border-t border-white/10 py-8 md:py-12 snap-start">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center mb-8">
            <nav className="mb-6 md:mb-0">
              <ul className="flex flex-wrap justify-center md:justify-start gap-6 md:gap-8">
                <li>
                  <span className="text-white/60 hover:text-white/90 transition-colors text-sm cursor-not-allowed">
                    Docs
                    <span className="ml-2 text-xs text-white/40">(Coming Soon)</span>
                  </span>
                </li>
                <li>
                  <a
                    href="#contact-section"
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('contact-section').scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-white/60 hover:text-white/90 transition-colors text-sm"
                  >
                    Book a Call
                  </a>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-white/60 hover:text-white/90 transition-colors text-sm"
                  >
                    About
                  </Link>
                </li>
                <li>
                  <Link
                    to="/privacy"
                    className="text-white/60 hover:text-white/90 transition-colors text-sm"
                  >
                    Privacy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/careers"
                    className="text-white/60 hover:text-white/90 transition-colors text-sm"
                  >
                    Careers
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-white/40 text-sm mb-4 md:mb-0">
              © 2025 Orchestra, Inc. – Built in San Francisco
            </p>
            <a
              href="mailto:drake@orchestraos.com"
              className="text-white/60 hover:text-blue-400 transition-colors text-sm group relative"
              title="drake@orchestraos.com"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default A16Z; 